module.exports = __webpack_public_path__ + "img/icon-photos.72445909.svg";